var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.rows),function(row){return _c('div',{staticStyle:{"clear":"both"}},[_vm._l((_vm.columns),function(col){return [_c('v-size-chart-cell',{attrs:{"cell":_vm.GetCell(row-1, col-1)}})]})],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b7f80ef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sizeChart/SizeChart.vue
// module id = null
// module chunks = 